//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetExternalFileSpec",{R_:{fileSpec:''}},0,0],[[],"GetExternalFileName",{R_:{fileName:''}},0,0],[["nrefs","objects"],"GetReferencingApplicationObjects",{},0,0],[["status"],"GetTimeStampWithStatus",{R_:{timeStampValue:''}},0,0]],[]];
SPLM.ExternalFileReference = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ExternalFileReference";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ExternalFileReference.Status = Object.freeze({
    "Ok" : "Ok", "FileMoved" : "FileMoved", "FileOutOfDate" : "FileOutOfDate", "FileNotFound" : "FileNotFound", "Invalid" : "Invalid"});

export default SPLM;